import { Flex, Th, TableColumnHeaderProps } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useResource } from "hooks/resources/providers/resourceProvider";

interface ThSorterProps extends TableColumnHeaderProps {
	children: React.ReactNode;
	field: string;
}

export function ThSorter({ children, field, ...props }: ThSorterProps) {
	const { sort } = useResource<unknown>();

	function handleSort(e: React.MouseEvent<HTMLDivElement>) {
		e.preventDefault();
		if (sort.config.field === field) {
			sort.setSort(field, sort.config.direction === "asc" ? "desc" : "asc");
		} else {
			sort.setSort(field, "asc");
		}
	}

	function getSortIcon() {
		if (sort.config.field === field) {
			return sort.config.direction === "asc" ? (
				<FontAwesomeIcon
					icon={["fas", "sort-down"]}
					style={{ marginTop: "-4px" }}
				/>
			) : (
				<FontAwesomeIcon
					icon={["fas", "sort-up"]}
					style={{ marginTop: "8px" }}
				/>
			);
		}
		return <FontAwesomeIcon icon={["fas", "sort"]} />;
	}

	return (
		<Th onClick={handleSort} cursor="pointer" {...props}>
			<Flex gap={2} alignItems="center">
				{children}
				{getSortIcon()}
			</Flex>
		</Th>
	);
}
